import { NgClass, NgStyle } from '@angular/common';
import {
    Component,
    input,
    model,
    OnChanges,
    signal,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';

/**
 * Mensagem temporária que aparece e some sozinha após alguns segundos.
 *
 * Ao receber {@link show} = `true`, a mensagem fica visível (opacidade 1) e,
 * após {@link seconds} segundos, esmaece (opacidade 0). A cor varia conforme
 * {@link severity} e o tamanho conforme {@link size}.
 */
@Component({
    selector: 'ai-temporary-message',
    templateUrl: 'temporary-message.component.html',
    styleUrls: ['./temporary-message.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    imports: [NgClass, NgStyle],
})
export class TemporaryMessage implements OnChanges {
    /** Texto exibido (obrigatório). */
    message = input.required<string>();

    /** Tempo, em segundos, até a mensagem esmaecer. */
    seconds = input<number>(5);

    /** Tamanho do texto. */
    size = input<'small' | 'medium' | 'large'>('small');

    /** Severidade, que define a cor da mensagem. */
    severity = input<'info' | 'success' | 'warning' | 'danger'>('info');

    /** Controla a visibilidade (two-way via `model`). */
    show = model<boolean>(true);

    /** Efeito de transição aplicado. */
    effect = input<'fade'>('fade');

    protected opacity = signal<number>(0);

    private timeoutId: ReturnType<typeof setTimeout> | undefined;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['show'] && changes['show'].currentValue === true) {
            this.opacity.set(1);

            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }

            this.timeoutId = setTimeout(() => {
                this.opacity.set(0);
            }, this.seconds() * 1000);
        }
    }
}
